import React from 'react';

const STEPS = [
  { n:1, title:'Find your flavour', desc:'Browse the gallery & menu, save what you love.' },
  { n:2, title:'Message us',        desc:'Send the flavour, date and your message on WhatsApp.' },
  { n:3, title:'We bake it',        desc:'We confirm, hand-pipe it fresh, and ready it for pickup or delivery.' },
];

export default function Steps() {
  return (
    <section style={{ padding:'0 0 92px' }}>
      <div style={{ maxWidth:1180, margin:'0 auto', padding:'0 26px' }}>
        <div style={{ textAlign:'center', maxWidth:620, margin:'0 auto 44px' }}>
          <span style={{ fontFamily:'var(--sans)', fontWeight:700, fontSize:12, letterSpacing:2.6, textTransform:'uppercase', color:'var(--plum)', display:'inline-flex', alignItems:'center', justifyContent:'center', gap:9 }}>
            How it works
          </span>
          <h2 style={{ fontSize:'clamp(2.3rem,4.4vw,3.4rem)', margin:'12px 0 12px' }}>Ordering is a conversation</h2>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:22 }} className="kt-steps">
          {STEPS.map(({ n, title, desc }) => (
            <div key={n} style={{ textAlign:'center', padding:10 }}>
              <div style={{ width:58, height:58, borderRadius:'50%', border:'1.6px solid var(--plum)', color:'var(--plum-deep)', fontFamily:'var(--serif)', fontSize:28, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', background:'var(--blush)' }}>
                {n}
              </div>
              <h3 style={{ fontSize:23, marginBottom:6 }}>{title}</h3>
              <p style={{ color:'var(--ink-2)', fontSize:15, margin:'0 auto', maxWidth:'30ch' }}>{desc}</p>
            </div>
          ))}
        </div>
      </div>
      <style>{`@media(max-width:860px){.kt-steps{grid-template-columns:1fr!important;gap:34px;max-width:360px;margin:0 auto;}}`}</style>
    </section>
  );
}
